module.exports = __webpack_public_path__ + "img/em-tempering-01.96624273.jpg";